import type { User } from '~/types';
import { useMemo, useState } from 'react';
import { Col, H2, Row } from '@workramp/ui';
import { UserListItem } from '~/features/common';
import { I18n } from '~/common/explicit-exports';
import { LearnerPagination } from '../LearnerPagination';
import { PaginationWrapper } from './Attendees.styles';

const { APP_CONSTANTS } = window;

const statuses = APP_CONSTANTS.EVENT_ATTENDEE_STATUSES;

type Props = {
  attendees: {
    id: string;
    status: string;
    user: User;
  }[];
};

const PAGE_SIZE = 10;

export const Attendees = ({ attendees }: Props) => {
  const [page, setPage] = useState(0);

  const TRANSLATED_ATTENDEES = I18n.t('js.learner.events.sessions.modals.attendees.title');

  const filteredAttendees = useMemo(
    () =>
      attendees.filter(
        (attendee) =>
          attendee.status === statuses.registered ||
          attendee.status === statuses.attended ||
          attendee.status === statuses.absent ||
          attendee.status === statuses.waitlisted,
      ),
    [attendees],
  );

  const sortedAttendees = useMemo(
    () =>
      [...filteredAttendees].sort((a, b) => (a.user.name || a.user.email).localeCompare(b.user.name || b.user.email)),
    [filteredAttendees],
  );

  const pagedAttendees = useMemo(
    () => sortedAttendees.slice(page * PAGE_SIZE, page * PAGE_SIZE + PAGE_SIZE),
    [page, sortedAttendees],
  );

  if (!filteredAttendees.length) {
    return null;
  }

  return (
    <>
      <H2 size={1}>{TRANSLATED_ATTENDEES}</H2>
      <Row>
        {pagedAttendees.map((attendee) => (
          <Col key={attendee.id} xs={12} sm={6}>
            <UserListItem name={attendee.user.name} avatar={attendee.user.avatar} label={attendee.user.email} />
          </Col>
        ))}
      </Row>
      <PaginationWrapper>
        <LearnerPagination page={page} pageSize={PAGE_SIZE} total={filteredAttendees.length} onChangePage={setPage} />
      </PaginationWrapper>
    </>
  );
};
